import * as React from 'react'
import Hide, {HideProps} from './Hide'

export interface DesktopProps extends Omit<HideProps, '$on'> {
  children: React.ReactNode
}

const Desktop = React.forwardRef<HTMLElement, DesktopProps>(({children, ...props}, ref) => {
  return (
    <Hide ref={ref} $on={['small']} {...props}>
      {children}
    </Hide>
  )
})

Desktop.displayName = 'Desktop'

export default Desktop
